import {useQuery} from '@tanstack/react-query';
import {DEAL_STATUSES, OFFER_CATEGORIES, QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type UseFetchDealsProps = {
  reservationId?: string;
  category?: OFFER_CATEGORIES;
  status?: DEAL_STATUSES;
  enabled?: boolean;
};

function useFetchDeals({
  reservationId,
  category,
  status,
  enabled = true,
}: UseFetchDealsProps) {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.deals, reservationId, category, status],
    queryFn: () => {
      const params = new URLSearchParams({
        reservation_id: reservationId!,
        is_active: 'true',
      });

      if (category) {
        params.append('category', category);
      }
      if (status) {
        params.append('status', status);
      }

      return API.upselling.getDeals(params.toString());
    },
    enabled: enabled && Boolean(reservationId),
  });
}

export {useFetchDeals};
